var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canShowChart)?_c('FunnelChart',{attrs:{"config":_vm.chartConfig,"widget-type":_vm.widgetType,"disable-error-messages":_vm.disableErrorMessages},on:{"frame-ended":_vm.setIdle}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }